import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ManageExternalTechnicians from 'components/shared/manage-external-users/manage-external-technicians.component';

type ShareWithExternalDialogProps = {
    orderId?: string;
    onClose: () => void;
    open: boolean;
};
const ShareWithExternalDialog: FC<ShareWithExternalDialogProps> = ({
    orderId,
    onClose,
    open,
}: ShareWithExternalDialogProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle>{translate('orders:MANAGE_EXTERNAL_USERS')}</DialogTitle>
            <DialogContent sx={{ minHeight: 200 }}>
                <Box mt={1}>{orderId ? <ManageExternalTechnicians orderId={orderId} /> : undefined}</Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('CLOSE')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ShareWithExternalDialog;
